// extracted by mini-css-extract-plugin
export default {"formWrapper":"JVyatHuG","form":"k74_lTw4","title":"kFWTHqUS","field":"S27yd77G","modWrapper":"iVQU35ql","ageWrapper":"v9aIcFch","modButton":"tLSb0D0R","notion":"iRgmFFkq","error":"wNIpzgt_","agreementCheckbox":"TYmt3AvI","agreement":"sbExV5gs","flexWrapper":"g7TicKym","agreementLink":"SnW8QmrO","active":"AMc1f_R1"};
    if(module.hot) {
      // 1712151479790
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  